module.exports = __webpack_public_path__ + "images/c5420420ad37d299088d16ea2d3107b6.png";